module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm08_ill"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURES")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01fig1"
    }
  }, [_vm._v("1. Paleo-American hunting scene")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01fig2"
    }
  }, [_vm._v("2. Projectile points from Paleo-American, Archaic, and Neo-American stages")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch03fig1"
    }
  }, [_vm._v("3. Coahuiltecan carrying a burden")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Karankawa dancers")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Lipan warrior and his wife")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Tonkawa burial scene")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Comanche warrior")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Kiowa sun dancer")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. “Standing on top of their houses they showed great merriment on seeing us.” (Hernán Gallegos)")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Tattooed Wichita women plaiting pumpkin fibers")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Caddo village scene")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Atakapan in a dugout canoe")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APS")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02map1"
    }
  }, [_vm._v("1. Texas Tribes of the Western Gulf Culture Area")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04map2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Southern Plains and Southwest Texas in Prehorse Times")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Texas Plains, 19th Century")])]), _vm._v(" "), _c('p', {
    staticClass: "indentm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Texas Tribes of the Southeast Culture Area")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fc881e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm08_ill.vue
// module id = 81
// module chunks = 0